import { PAYMENT_SERVICE_PATH, PAYMENT_SERVICE_PUBLIC_PATH } from '@shared/constants/paths';
import {
  useLazyGetInvoiceReceiptQuery,
  useLazyGetPublicInvoiceReceiptQuery,
  useSubmitInvoiceReceiptEmailMutation,
  useSubmitPublicInvoiceReceiptEmailMutation,
} from '@shared/services/bills';
import {
  useGetPaymentServiceStatusQuery,
  useGetPublicPaymentServiceStatusQuery,
} from '@shared/services/paymentService';

export const getPaymentReceiptConfig = () => ({
  public: {
    getPaymentInfoQuery: useGetPublicPaymentServiceStatusQuery,
    getReceiptPdfQuery: useLazyGetPublicInvoiceReceiptQuery,
    navigateBackURL: PAYMENT_SERVICE_PUBLIC_PATH,
    sendEmailRequestMutation: useSubmitPublicInvoiceReceiptEmailMutation,
  },
  singpass: {
    getPaymentInfoQuery: useGetPaymentServiceStatusQuery,
    getReceiptPdfQuery: useLazyGetInvoiceReceiptQuery,
    navigateBackURL: PAYMENT_SERVICE_PATH,
    sendEmailRequestMutation: useSubmitInvoiceReceiptEmailMutation,
  },
});
